import React from "react"
import { getBgColor, getBgImage, Target } from "../../../utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFax, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons"
import { faInstagram, faLine } from "@fortawesome/free-brands-svg-icons"

type Props = {
  target: Target
  tel: string
  openingHour: string
  lineId: string
  addFriendLink: string
  fax: string
  email: string
  instagram: string
}

const ContactOther: React.VFC<Props> = ({
  target,
  tel,
  openingHour,
  lineId,
  addFriendLink,
  fax,
  email,
  instagram,
}) => {
  return (
    <div
      className={`md:flex p-8 mt-12 md:mt-16 ${getBgImage(target)} rounded-md`}
    >
      <div className="text-center md:w-1/2">
        <div className="flex items-center justify-center">
          <FontAwesomeIcon icon={faPhone} size="2x" color="dimgray" />
          <a href={`tel:${tel}`} className="block ml-5 text-2xl font-kiwiMaru">
            {tel}
          </a>
        </div>
        <div className="mt-5 whitespace-pre-wrap md:mt-8">
          <div>受付時間</div>
          <div>{openingHour}</div>
        </div>
      </div>
      <div className="hidden border-dash-y md:block"></div>
      <div className="mt-8 md:w-1/2 md:mt-0">
        <div className="mx-auto space-y-3 md:space-y-4 w-fit">
          <div className="flex items-center">
            <FontAwesomeIcon icon={faLine} size="2x" color="dimgray" />
            <div className="ml-3">{lineId}</div>
            <a
              href={`https://lin.ee/${addFriendLink}`}
              target="_blank"
              className={`px-3 md:px-5 py-2 ml-5 text-sm text-white rounded-md ${getBgColor(
                target
              )} font-kiwiMaru`}
            >
              友達追加
            </a>
          </div>
          <div className="flex items-center">
            <FontAwesomeIcon icon={faInstagram} size="2x" color="dimgray" />
            <a
              href={`https://www.instagram.com/${instagram}/`}
              className="block ml-3 underline hover:no-underline"
            >
              @{instagram}
            </a>
          </div>
          <div className="flex items-center">
            <FontAwesomeIcon icon={faFax} size="lg" color="dimgray" />
            <div className="ml-3">{fax}</div>
          </div>
          <div className="flex items-center">
            <FontAwesomeIcon icon={faEnvelope} size="lg" color="dimgray" />
            <a
              href={`mailto:${email}`}
              className="block ml-3 underline hover:no-underline"
            >
              {email}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactOther
